// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import LiveCursorNameTag from './LiveCursorNameTag';
import Icon from '../../../../components/icons/Icon';

// Styles
import './LiveCursorTypePointer.scss';

const LiveCursorTypePointer = ({ user }) => (
    <div className="cursor LiveCursorTypePointer">
        <Icon name="cursor-remote-select" />
        <LiveCursorNameTag user={user} />
    </div>
);

LiveCursorTypePointer.propTypes = {
    user: PropTypes.object,
};

export default LiveCursorTypePointer;
